import Portfolio from "../Entities/Portfolio";
import PageStyle from "../../Components/Enums/PageStyle";

const GamesOfChance: Portfolio = {
    path: "games-of-chance", name: "Games of Chance", pageStyle: PageStyle.Tan, pieces: [
        {
            image: "games-of-chance-01.jpg",
            thumbAlt: "Games of Chance",
            title: "Chance\nCollage Monotype",
            size: "8 \u00d7 8",
            pixelWidth: 360,
            pixelHeight: 360
        },
        {
            image: "games-of-chance-02.jpg",
            thumbAlt: "Games of Chance",
            title: "Disparity\nCollage Monotype",
            size: "8 \u00d7 8",
            pixelWidth: 356,
            pixelHeight: 360
        },
        {
            image: "games-of-chance-03.jpg",
            thumbAlt: "Games of Chance",
            title: "Escape\nCollage Monotype",
            size: "8 \u00d7 8",
            pixelWidth: 360,
            pixelHeight: 360
        },
        {
            image: "games-of-chance-04.jpg",
            thumbAlt: "Games of Chance",
            title: "Flicker\nCollage Monotype",
            size: "8 \u00d7 8",
            pixelWidth: 360,
            pixelHeight: 360
        },
        {
            image: "games-of-chance-05.jpg",
            thumbAlt: "Games of Chance",
            title: "Gravity\nCollage Monotype",
            size: "8 \u00d7 8",
            pixelWidth: 360,
            pixelHeight: 360
        },
        {
            image: "games-of-chance-06.jpg",
            thumbAlt: "Games of Chance",
            title: "Impermanence\nCollage Monotype",
            size: "8 \u00d7 8",
            pixelWidth: 360,
            pixelHeight: 360
        },
        {
            image: "games-of-chance-07.jpg",
            thumbAlt: "Games of Chance",
            title: "Osmosis\nCollage Monotype",
            size: "8 \u00d7 8",
            pixelWidth: 360,
            pixelHeight: 360
        },
        {
            image: "games-of-chance-08.jpg",
            thumbAlt: "Games of Chance",
            title: "Pathways\nCollage Monotype",
            size: "8 \u00d7 8",
            pixelWidth: 346,
            pixelHeight: 360
        },
        {
            image: "games-of-chance-09.jpg",
            thumbAlt: "Games of Chance",
            title: "Radio Waves\nCollage Monotype",
            size: "8 \u00d7 8",
            pixelWidth: 360,
            pixelHeight: 360
        },
        {
            image: "games-of-chance-10.jpg",
            thumbAlt: "Games of Chance",
            title: "Wisdom\nCollage Monotype",
            size: "8 \u00d7 8",
            pixelWidth: 360,
            pixelHeight: 360
        },
        // There were twelve images in the PHP code, but I only see 10 on the web page and in the files?
        // {image: "games-of-chance-11.jpg", thumbAlt: "Games of Chance", title: "Totem\nCollage Monotype", size: "8 \u00d7 8"},
        // {image: "games-of-chance-12.jpg", thumbAlt: "Games of Chance", title: "Understanding\nCollage Monotype", size: "8 \u00d7 8"},
    ],
    piecesColumns: 5,
    statementTitle: "A Game of Chance: … Chance by Choice",
    statement: {
        leftColumn: [
            "Everything in life is \"chance\" and we, as humans, play the \"game of chance\" every day. Life is a " +
            "perpetual dance with the unknown. We are essentially \"leaves in the stream.\"",
            "However…\n" +
            "the human opportunity, as one navigates the stream, is \"choice.\"",
            "John Steinbeck in East of Eden, referring to a Biblical verse in Genesis that states \"thou shalt,\" " +
            "evokes the alternate expression, \"thou mayest\" (timshel in Hebrew). He is exploring the idea of " +
            "human choice and speaking to the distinction of humans having the ability to make life choices. We " +
            "are swept along by the stream of chance, but all our outcomes are impacted by intention. He describes " +
            "the \"glittering instrument, the human soul. It is a lovely and unique thing in the universe… because " +
            "'thou mayest.'\""
        ],
        rightColumn: [
            "So the game is a game of chance - life as it happens - and choice, the longing of the soul, as the " +
            "vehicle of our deepest intentions. Both are equally significant and always at work to affect human " +
            "destiny, synchronously influencing one another.",
            "These prints engage this idea in multiple ways. Each print provides a visual image for an act or " +
            "concept that could be either chance or choice. It introduces an interesting question by offering " +
            "small vignettes for discussion.",
            "Even the act of making these collages engages chance and choice. The materials are \"chance\" " +
            "materials from repurposed prints…offering what is left. Careful choices are then made to " +
            "construct the images from these random pieces.",
            "Erika Radich\n" +
            "March 2020"
        ]
    }
};

export default GamesOfChance;